import { render, staticRenderFns } from "./configurationSecondAdd.vue?vue&type=template&id=74bcf03f&scoped=true&"
import script from "./configurationSecondAdd.vue?vue&type=script&lang=js&"
export * from "./configurationSecondAdd.vue?vue&type=script&lang=js&"
import style0 from "./configurationSecondAdd.vue?vue&type=style&index=0&id=74bcf03f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bcf03f",
  null
  
)

export default component.exports